import { SxProps, Theme } from '@mui/material';
import { siteColors } from '../../../../shared/constants/colors';

export function getStyles(isDesktopOrLaptop: boolean):  ({ [key:string]: SxProps<Theme> }) {
    return {
        root: {
            width: 'auto',
            minWidth: '100%',
            backgroundColor: siteColors.Tertiary,
            py: '20px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            mx: 0,
            color: '#fff',
            textAlign: 'center'
        },
        '& > *': {
            flex: 2
        },
        siteMapLinks: {
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: isDesktopOrLaptop ? 'row' : 'column',
            marginTop: '40px',
            marginLeft: '100px',
            marginRight: '100px'
        },
        linkText: {
            color: '#fff',
            marginBottom: '5px',
            fontWeight: 400,
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center'
        },
        copyright: {
            fontSize: '14px',
            marginTop: '10px',
            fontWeight: 400,
            lineHeight: '20px',
            boxSizing: 'border-box'
        },
        trademark: {
            fontSize: '14px',
            marginTop: '5px',
            lineHeight: '20px'
        },
        privacyPolicy: {
            fontSize: '16px',
            marginTop: '5px',
            display: 'flex',
            justifyContent: 'center',
            textSizeAdjust: '100%',
            lineHeight: '20px',
            fontWeight: 400,
            boxSizing: 'border-box'
        },
        privacyPolicyLink: {
            color: '#fff',
            fontWeight: 400,
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center'
        },
        linkSection: {
            display: 'flex',
            flexDirection: 'column',
            float: 'left',
            boxSizing: 'border-box',
            width: isDesktopOrLaptop ? '25%' : 'unset',
            lineHeight: '20px',
            minHeight: '1px',
            px: '10px',
            position: 'relative'
        },
        linkSectionHeader: {
            fontSize: '20px',
            fontWeight: 700,
            marginTop: isDesktopOrLaptop ? 'unset' : '20px',
            marginBottom: '20px',
            lineHeight: '20px',
            color: '#fff'
        },
        copyrightSection: {
            display: 'flex',
            flexDirection: 'column',
            fontSize: '16px',
            fontWeight: 300,
            justifyContent: 'flex-end',
            marginTop: '20px',
        }
    }
};
